/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { InputSizesType, InputVariantType } from '../ThemeProvider/types';

export const SimpleDateInputContainer = styled.div`
  position: relative;
`;

export const InputPattern = styled.div<{
  size: InputSizesType;
  variant: InputVariantType;
  hasError: boolean;
  isFullDate: boolean;
  isMobile: boolean;
}>`
  position: absolute;
  text-align: right;
  font-family: 'Mulish', sans-serif;
  letter-spacing: ${({ isMobile }) => (isMobile ? '0.025rem' : '2px')};
  color: ${({ theme, hasError }) => (hasError ? theme.status.error.color : theme.gray80)};
  font-size: ${({ theme, size }) => theme.input.sizes[size]?.fontSize}px;
  width: ${({ size, isFullDate }) =>
    isFullDate ? (size === 'standard' ? 85 : 75) : size === 'standard' ? 60 : 53}px;

  /* Calcula left basándose en variant e isMobile */
  left: ${({ variant, isMobile }) => {
    switch (variant) {
      case 'underline':
        return isMobile ? '0.25rem' : '1rem';
      case 'contained-label':
        return isMobile ? '1.25rem' : '2rem';
      case 'top-aligned-label':
        return isMobile ? '1.25rem' : '2rem';
      default:
        return isMobile ? '0.5rem' : '1rem';
    }
  }};

  /* Calcula top basándose en variant, size e isFullDate */
  top: ${({ variant, size, isFullDate }) => {
    switch (variant) {
      case 'underline':
        return size === 'small' ? '24px' : '22px';
      case 'contained-label':
        return size === 'small' ? '32px' : '28px';
      case 'top-aligned-label':
        if (isFullDate) return '44px';
        return size === 'small' ? '44px' : '40px';
      default:
        return size === 'small' ? '22px' : '28px';
    }
  }};
`;

export const UnitText = styled.p<{ size: InputSizesType; hasError: boolean }>`
  color: ${({ theme, hasError }) => (hasError ? theme.status.error.color : theme.gray80)};
  font-weight: 400;
  line-height: ${({ theme, size }) => theme.input.sizes[size]?.lineHeight}px;
  font-size: ${({ theme, size }) => theme.input.sizes[size]?.fontSize}px;
  padding-bottom: 0;
`;
